/*
 * The Types pages (1.B-2): layout only. Colors, spacing and type come from the kit's tokens.
 */
.cx-types {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: calc(880px * var(--cx-page-scale, 1));
  margin: 0 auto;
  padding: 24px 16px 48px;
}

.cx-types h1,
.cx-types h2,
.cx-types h3 {
  margin: 0;
  font-family: var(--cx-font-heading);
  font-weight: var(--cx-weight-heading);
}

.cx-types__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.cx-types__list {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid var(--cx-border);
  border-radius: var(--cx-radius-card);
}

.cx-types__row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 8px 12px;
  border-top: 1px solid var(--cx-border);
}

.cx-types__row:first-child {
  border-top: 0;
}

.cx-types__name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--cx-text);
  font-weight: 600;
  text-decoration: none;
}

.cx-types__name:hover {
  text-decoration: underline;
}

.cx-types__muted {
  color: var(--cx-text-muted);
  font-size: 0.875em;
}

.cx-types__plural {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cx-types__count {
  min-width: 2.5em;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.cx-types__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.cx-types__form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.cx-types__form fieldset,
.cx-types__options {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.cx-types__form legend,
.cx-types__options legend {
  padding: 0;
  font-weight: 600;
}

.cx-types__looks {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 6px;
  margin-top: 6px;
}

.cx-types__look {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border: 1px solid var(--cx-border);
  border-radius: var(--cx-radius-control);
}

.cx-types__look:has(input:checked) {
  border-color: var(--cx-accent);
}

.cx-types__caps {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 6px;
}

.cx-types__options ul {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 6px 0;
  padding: 0;
  list-style: none;
}

.cx-types__options li {
  display: flex;
  align-items: flex-end;
  gap: 4px;
}

.cx-types__options li .cx-field {
  flex: 1;
}

.cx-types__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875em;
}

.cx-types__table th,
.cx-types__table td {
  padding: 4px 8px;
  border-bottom: 1px solid var(--cx-border);
  text-align: left;
  overflow-wrap: anywhere;
}

.cx-types__scroll {
  max-height: 40vh;
  overflow: auto;
}

@media (max-width: 640px) {
  .cx-types__row {
    flex-wrap: wrap;
  }

  .cx-types__plural {
    display: none;
  }
}
